export class FormFormat {
    id: string;
    code: string;
    name: string;
    bizCategory: string;
    formUrl: string;
    urlType: string;
    formatType: string;
    status: number;
    urlParameters: Array<FormatParameter>;
    formButtons: Array<FormButton>;
    formFields: Array<FormFieldData>;
    extendParameters: string;
}

export class FormFieldData {
    data: FormField;
    expanded: boolean;
    leaf: boolean;
    children: Array<FormFieldData>;
}

export class FormatParameter {
    code: string;
    name: string;
    value: string;
}

export class FormButton {
    id: string;
    buttonId: string;
    buttonName: string;
    buttonState: string;
    description: string;
    sortOrder: number;
    formFormatId: string;
}

export class FormField {
    id: string;
    fieldId: string;
    fieldName: string;
    fieldState: string;
    description: string;
    sortOrder: number;
    formFormatId: string;
}
